import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const ChatApi = {
    getChatSettings: (webinarId: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['chat', 'getChatSettings', webinarId], (api) => api.chat.getChatSettings(webinarId), options),
    setChatSettings: (options?: BaseApiMutationOptions<ApiClient['chat']['setChatSettings']>) => apiMutationOptions((api) => api.chat.setChatSettings, options)
};
